import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-9 py-6" }
const _hoisted_2 = { class: "font-lora text-3xl text-gray-900" }
const _hoisted_3 = { class: "flex gap-6" }

import CalculationStepper from '../components/CalculationStepper.vue';

import { useCurrentSegment } from '../composables/useCurrentSegment';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationLayout',
  setup(__props) {

const { currentSegment } = useCurrentSegment();

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(currentSegment)?.name || _ctx.$route.meta.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CalculationStepper, { class: "h-max max-h-[70vh] shrink-0 basis-[354px] overflow-y-auto" }),
      _createVNode(_component_RouterView, { class: "flex-1" })
    ])
  ]))
}
}

})